import styled from '@emotion/styled';
import Image from '@base/Image';
import { Spacings, Fonts } from '@styles/index';
import { DPP_STATS_MAP } from './constants';

const StatisticsWrapper = styled.div`
  display: flex;
  margin-right: ${Spacings.SPACING_7B};
`;

const StatisticsText = styled.div`
  font-size: ${Fonts.ULTRA_SMALL};
  margin: auto;
  color: var(--color-i-gray);
  margin-left: ${Spacings.SPACING_2B};
`;

const Statistics = ({ data }) => {
  const stats = DPP_STATS_MAP?.[data?.code];

  if (!stats) {
    return null;
  }

  return (
    <StatisticsWrapper>
      <Image width={24} height={24} alt="statistics-icon" src={stats.icon} />
      <StatisticsText>
        {data?.value} {stats.text}
      </StatisticsText>
    </StatisticsWrapper>
  );
};

export default Statistics;
